// Locale routing, shared by gatsby-node (CommonJS) and the site code. Kept
// free of JSX and ES module syntax so Node can require() it at build time.

// Spanish is the site's main language and lives at the root; every other
// language gets its own prefix (/it/, /en/).
const defaultLocale = "es";
const locales = ["es", "it", "en"];

// Written in their own language, so a reader finds theirs on sight.
const localeNames = {
  es: "Español",
  it: "Italiano",
  en: "English",
};

const prefixPattern = new RegExp(
  `^/(${locales.filter((l) => l !== defaultLocale).join("|")})(?=/|$)`
);

function localeFromPath(pathname = "/") {
  const match = pathname.match(prefixPattern);
  return match ? match[1] : defaultLocale;
}

// "/it/videos/" → "/videos/", "/en" → "/"
function stripLocale(pathname = "/") {
  return pathname.replace(prefixPattern, "") || "/";
}

// "/videos/" → "/it/videos/" for Italian, unchanged for Spanish.
function localizePath(path, locale) {
  if (!locale || locale === defaultLocale) return path;
  return `/${locale}${path.startsWith("/") ? path : `/${path}`}`;
}

module.exports = {
  defaultLocale,
  locales,
  localeNames,
  localeFromPath,
  stripLocale,
  localizePath,
};
